import { makeStyles } from "tss-react/mui";
import { treeItemClasses } from "@mui/x-tree-view/TreeItem";
const useStyles = makeStyles()((theme)=>({
        root: {
            '& > ul': {
                marginLeft: 0,
                '& li': {
                    paddingLeft: theme.px(17)
                }
            }
        },
        selected: {
            ["&:after, &:hover:after"]: {
                display: 'block',
                background: theme.tokens.colors.original.brand.secondary
            }
        },
        focused: {
            background: 'transparent'
        },
        content: {
            padding: 0,
            gap: 0,
            position: 'relative',
            zIndex: 1,
            [`&:focus >  .${treeItemClasses.label}`]: {
                backgroundColor: 'transparent'
            },
            [`&.${treeItemClasses.selected} > .${treeItemClasses.label}`]: {
                backgroundColor: 'transparent',
                color: theme.tokens.colors.original.brand.primary
            },
            [`&.${treeItemClasses.selected} > .${treeItemClasses.label}:hover`]: {
                backgroundColor: 'transparent',
                color: theme.tokens.colors.original.brand.primary
            },
            [`&.${treeItemClasses.selected}:focus > .${treeItemClasses.label}`]: {
                backgroundColor: 'transparent',
                color: theme.tokens.colors.original.brand.primary
            },
            [`&.${treeItemClasses.selected} > .${treeItemClasses.iconContainer}`]: {
                color: theme.tokens.colors.original.brand.primary
            },
            '&:after': {
                position: 'absolute',
                display: 'none',
                content: '""',
                left: theme.px(-200),
                top: 0,
                bottom: 0,
                right: 0,
                background: theme.tokens.colors.bg.greyscale.primary,
                zIndex: -1
            },
            '&:hover': {
                backgroundColor: 'transparent',
                '&:after': {
                    display: 'block',
                    background: theme.tokens.colors.bg.greyscale.primary
                }
            }
        },
        iconContainer: {
            display: 'flex',
            alignItems: 'center',
            width: theme.px(42),
            height: theme.px(48),
            marginRight: 0,
            color: theme.tokens.colors.text.light.tertirary
        },
        label: {
            fontSize: theme.tokens.typography.variant.subtitle2.fontSize,
            lineHeight: theme.tokens.typography.variant.subtitle2.lineHeight,
            padding: `${theme.tokens.spacing['12']}px ${theme.tokens.spacing['20']}px ${theme.tokens.spacing['12']}px 0`,
            '&:hover': {
                backgroundColor: 'transparent'
            }
        },
        groupTransition: {
            position: 'relative',
            '&:after': {
                position: 'absolute',
                display: 'block',
                content: '""',
                width: theme.px(2),
                left: theme.tokens.spacing['2'],
                top: theme.tokens.spacing['2'],
                bottom: theme.tokens.spacing['2'],
                background: theme.tokens.colors.stroke.primary
            }
        },
        itemLabel: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            columnGap: theme.tokens.spacing['16']
        },
        itemCounter: {
            background: theme.tokens.colors.bg.greyscale.primary,
            fontSize: theme.tokens.typography.variant.caption.fontSize,
            lineHeight: theme.tokens.typography.variant.caption.lineHeight,
            padding: `${theme.tokens.spacing['4']}px ${theme.tokens.spacing['8']}px`,
            borderRadius: theme.tokens.radius.s
        },
        itemDisabled: {
            color: theme.tokens.colors.text.light.tertirary,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between'
        }
    }));
export { useStyles };
